module.exports = __webpack_public_path__ + "img/resource_centre.d983b4d5.svg";